export enum ENTITY_TYPE {
  CLIENT = 'CLIENT',
  SITE = 'SITE',
  REQUESTER = 'USER',
  ASSETS = 'ASSET'
}

export enum PROVISION_RULES_ACTIONS {
  ADD_PROVISION_RULE,
  REMOVE_PROVISION_RULE,
  UPDATE_PROVISION_RULE,
  UPDATE_PROVISION_RULES_LIST
}

export type DISPATCH_ARG =
  | {
      type: PROVISION_RULES_ACTIONS.ADD_PROVISION_RULE;
      payload: {
        provisionRuleData?: {};
      };
    }
  | {
      type: PROVISION_RULES_ACTIONS.REMOVE_PROVISION_RULE;
      payload: {
        provisionRuleId?: string;
      };
    }
  | {
      type: PROVISION_RULES_ACTIONS.UPDATE_PROVISION_RULE;
      payload: {
        provisionRuleId?: string;
        provisionRuleData?: {};
      };
    }
  | {
      type: PROVISION_RULES_ACTIONS.UPDATE_PROVISION_RULES_LIST;
      payload: {
        provisionRulesList?: Array<any>;
      };
    };

export enum USER_GUIDE {
  SERVICE = 'SERVICE',
  PRODUCT = 'PRODUCT',
  PACKAGE = 'PACKAGE',
  RECURRING_SERVICE_CONTRACT = 'RECURRING_SERVICE',
  USAGE_BASED_CONTRACT = 'USAGE',
  ONE_TIME_CONTRACT = 'ONE_TIME',
  TIME_AND_MATERIAL_CONTRACT = 'TIME_AND_MATERIAL'
}

export enum REACT_FLOW_NODE_TYPES {
  HEADER = 'headerNode',
  ADD = 'addNode'
}

export const INTEGRATION_KEYS = {
  PAX8: 'app.integrations.pax8',
  SPLASHTOP_WORK_FROM_HOME: 'integrations.splashtop',
  ISL_ONLINE_WORK_FROM_HOME: 'msp.isl.name'
};

export const HEADER_NODE_ID = 'headerId';
